module.exports = __webpack_public_path__ + "bba29c45e088a574ffb5de7248773061.png";